const getPathsFromPolygon = (polygon: google.maps.Polygon) => {
    const paths = polygon.getPaths().getArray();
    const newPolygon: number[][] = [];
    paths.forEach((path: google.maps.MVCArray<google.maps.LatLng>) => {
        const pathArr = path.getArray();
        pathArr.forEach(({ lat, lng }: google.maps.LatLng) => {
            newPolygon.push([lng(), lat()]);
        });
    });
    return [...newPolygon, newPolygon[0]];
};

const getPathsFromPolygonForDangerZone = (polygon: google.maps.Polygon) => {
    const paths = polygon.getPaths().getArray();
    const newPolygon: number[][] = [];
    paths.forEach((path: google.maps.MVCArray<google.maps.LatLng>) => {
        const pathArr = path.getArray();
        pathArr.forEach(({ lat, lng }: google.maps.LatLng) => {
            newPolygon.push([lng(), lat()]);
        });
    });
    if (newPolygon.length > 0
        && (newPolygon[0][0] !== newPolygon[newPolygon.length - 1][0]
         || newPolygon[0][1] !== newPolygon[newPolygon.length - 1][1])) {
        newPolygon.push([newPolygon[0][0], newPolygon[0][1]]);
    }
    return [newPolygon];
};

export {
    getPathsFromPolygon,
    getPathsFromPolygonForDangerZone,
};
